<template>
<div class="chapter">
<div class="inner_page">
<p class="P_RaggedRight" id="auto_bookmark_toc_1"><span style=" font-weight: bold; font-size: 1.17em;">Reid felt as good as he looked, all soft lips and solid body. And he tasted good too. Whiskey. Chocolate. Heaven. Jaxon’s appetite returned in full force, but it wasn’t airplane steak he was ravenous for.</span></p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Jaxon let go of the tie, but only so he could grasp Reid’s shoulders instead, and Reid responded in kind. For a glorious few seconds, they made out like horny teenagers.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">But before Jaxon could work out the logistics of joining the mile-high club—well, <span style=" font-style: italic; font-size: 1.00em;">rejoining</span>, since he was already a repeat member—Reid pulled away. He got off the bed and stood in the narrow space next to it, adjusting his tie. “We can’t do that,” he said evenly.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“Don’t tell me you’re not into guys, ’cause you were pretty into it.” For a moment anyway.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Reid shook his head. “This is a critical mission, and I’m your assistant. I need to make sure everything goes smoothly.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?ded9346e